import { pick } from 'ramda';

export default pick([
  'download',
  'href',
  'hrefLang',
  'media',
  'ping',
  'rel',
  'target',
  'type',
]);
